export function getDeviceId() {
  const STORAGE_KEY = "posTerminalId";

  // 1. Try to get the ID from local storage
  let deviceId = localStorage.getItem(STORAGE_KEY);

  // 2. If it doesn't exist, generate a new one
  if (!deviceId) {
    if (window.crypto && window.crypto.randomUUID) {
      deviceId = window.crypto.randomUUID(); // Modern browsers
    } else {
      // Fallback for older browsers
      deviceId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    }

    // 3. Save it permanently
    localStorage.setItem(STORAGE_KEY, deviceId);
  }

  return deviceId;
}
